import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import { getPermissions } from '../../Login/selectors';
import {
  setSelectedRole,
  toggleNewRole,
  updateChecks,
  updateRoleName,
} from '../../Roles/actions';
import {
  createRoleActionSagas,
  deleteRoleActionSagas,
  editRoleActionSagas,
  getPageRolesActionSagas,
  getPagesActionSagas,
} from '../../Roles/actionsSagas';
import {
  getAllRoles,
  getChecks,
  getNewRoleMode,
  getPages,
  getRoleName,
  getRolePagination,
  getSelectedRole,
  isCreating,
  isDeleting,
  isUpdating,
} from '../../Roles/selectors';
import Permissions from './Permissions';

const mapStateToProps = (state, ownProps) => ({
  roles: getAllRoles(state),
  pages: getPages(state),
  selectedRole: getSelectedRole(state),
  pagination: getRolePagination(state),
  creating: isCreating(state),
  updating: isUpdating(state),
  deleting: isDeleting(state),
  roleName: getRoleName(state),
  checks: getChecks(state),
  newRoleMode: getNewRoleMode(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleNewRole: (role) => dispatch(toggleNewRole(role)),
  onLoad: (page) => {
    dispatch(getPagesActionSagas());
    dispatch(getPageRolesActionSagas(page));
  },
  onSelect: (role) => {
    dispatch(setSelectedRole(role));
  },
  createRole: (role) => dispatch(createRoleActionSagas(role)),
  updateRole: (role) => dispatch(editRoleActionSagas(role)),
  deleteRole: (role) => dispatch(deleteRoleActionSagas(role)),
  setSelectedRole: (role) => dispatch(setSelectedRole(role)),
  updateRoleName: (name) => dispatch(updateRoleName(name)),
  updateChecks: (checks) => dispatch(updateChecks(checks)),
});

const PermissionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Permissions);

export default addAbilityToOpenModal(PermissionsContainer);
